export const EntityType = {
  CLIENTS: "clients",
  LOANS: "loans",
  STAFF: "staff"
};
